var exports = {
  "q": "x61f99309--ef12d3--footer",
};

module.exports = exports;
